import React from 'react'
import { Link } from '@reach/router'
import {
  FileSyncOutlined,
  ApartmentOutlined,
  FundOutlined,
} from '@ant-design/icons'
import { Tooltip } from 'antd'

const SideBar = (props) => {
  return (
    <div className="side-bar-nav">
      <Link to="/">
        <Tooltip title="P&L Report by Market" placement="right" color="#000">
          <div className="nav-item">
            <FileSyncOutlined style={{ color: '#7b188a', fontSize: 20 }} />
          </div>
        </Tooltip>
      </Link>
      <Link to="/ip-report">
        <Tooltip title="IP Report" placement="right" color="#000">
          <div className="nav-item">
            <ApartmentOutlined style={{ color: '#7b188a', fontSize: 20 }} />
          </div>
        </Tooltip>
      </Link>
      <Link to="/odds-analyzer">
        <Tooltip title="Odds Analyzer" placement="right" color="#000">
          <div className="nav-item">
            <FundOutlined style={{ color: '#7b188a', fontSize: 20 }} />
          </div>
        </Tooltip>
      </Link>
    </div>
  )
}

export default SideBar
